/** Keeps the memory details pocket inside its frame in workspace and Focus. */
import { forwardRef } from "react";
import { useMemoryStore } from "@/stores/memory-store";
import { MemoryPocket } from "./memory-pocket";

export const MemoryPocketHost = forwardRef<HTMLDivElement, { youName: string }>(
  function MemoryPocketHost({ youName }, ref) {
    const open = useMemoryStore((state) => state.pocketStack.length > 0);
    if (!open) return null;

    return (
      <MemoryPocket
        ref={ref}
        youName={youName}
        className="absolute right-3 top-3 z-[4] max-h-[calc(100%-24px)] max-w-[calc(100%-24px)]"
      />
    );
  },
);
